import { NgClass } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';

import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { ForecastMethodType } from '@shared/services/gql.service';
import { Option } from '@shared/types/components.type';

import { ForecastTableGridMethodChange } from '../../models/forecast-table-grid.model';

@Component({
  imports: [NgSelectComponent, TooltipDirective, NgClass, FormsModule, NgOptionComponent],
  selector: 'aux-forecast-table-grid-method-time',
  styleUrls: ['./forecast-table-grid-method-time.component.scss'],
  templateUrl: './forecast-table-grid-method-time.component.html',
})
export class ForecastTableGridMethodTimeComponent {
  @Input() categoryId = '';
  @Input() disabled = false;
  @ViewChild('gridMethodTime') public input!: NgSelectComponent;
  @Input() isChild = false;
  @Input() isInvalid = false;
  @Input() methodOptions: Option<ForecastMethodType>[] = [];
  @Input() onMethodChange!: ForecastTableGridMethodChange;
  @Input() placeholder = '';
  @Input() primarySettingsId = '';
  @Input() selectedForecastMethod = '';
  @Input() tooltip = '';

  onModelChange(event: string): void {
    this.onMethodChange(event, this.primarySettingsId, {
      id: this.categoryId,
      name: !this.isChild ? 'category' : 'activity',
      prop: 'forecast_method',
    });
  }
}
